<template>
	<div>
        <div class="scroll-nav">
            <div :class="classTabs">
                <ul :class="classNavigation">
                    <li v-for="(tab, index) in tabs" :key="index" :class="tab.isActive ? classActive : classItem">
                        <a :href="tab.href" @click="selectTab(tab)" :class="tab.classIcon">{{ tab.name }}</a>
                    </li>
                </ul>
            </div>
        </div>
            <div class="tabs-details">
                <slot></slot>
            </div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
    components: {
        "scrollbar":VuePerfectScrollbar,
    },
  props: {
    classTabs: { default: "tabs" },
    classNavigation: { default: "tabs-navigation" },
    classItem: { default: "tabs-navigation__item-min" },
    classActive: { default: "tabs-navigation__item-min-active" },
  },
  data() {
    return { 
        tabs: [],
        settings: {
            maxScrollbarLength: 120
        }, 
    };
  },

  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name == selectedTab.name;
        this.$emit('setTabs', selectedTab.name);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.scroll-nav {
    display: block;
    width: 100%;
    overflow: hidden;
    position: relative;
}
</style>
